var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "selected-language" },
    [
      _c("KIconButton", {
        staticClass: "globe px-8",
        attrs: { icon: "language", "aria-hidden": "true", tabindex: "-1" },
        on: {
          click: function ($event) {
            return _vm.$emit("click")
          },
        },
      }),
      _c(
        "span",
        {
          staticClass: "no-shrink px-8",
          attrs: { title: _vm.selectedLanguage.english_name },
        },
        [_vm._v("\n    " + _vm._s(_vm.selectedLanguage.lang_name) + "\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }